'use client';

import { c as _c } from "react/compiler-runtime";
import { CustomError, isEnumValue } from '@core/utils';
import { useSearchParams } from 'next/navigation';
import { COMMENT_SORT_TYPE } from '@/api';
import { SEARCH_PARAMS } from '@/constants';

// 댓글 정렬 상태는 다른 화면 공유와 새로고침 복원을 위해 URL에 남긴다.
export const replaceSortTypeInUrl = (sortType: COMMENT_SORT_TYPE) => {
  const url = new URL(window.location.href);
  url.searchParams.set(SEARCH_PARAMS.SORT_TYPE, sortType);
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
};

// CommentThread가 정렬 상태를 읽고 쓰는 최소 인터페이스만 노출한다.
export const useCommentThreadNavigation = () => {
  const $ = _c(8);
  const searchParams = useSearchParams();
  let rawSortType;
  let t0;
  if ($[0] !== searchParams) {
    rawSortType = searchParams?.get(SEARCH_PARAMS.SORT_TYPE) ?? COMMENT_SORT_TYPE.LATEST;
    t0 = isEnumValue(COMMENT_SORT_TYPE, rawSortType);
    $[0] = searchParams;
    $[1] = rawSortType;
    $[2] = t0;
  } else {
    rawSortType = $[1];
    t0 = $[2];
  }
  if (!t0) {
    throw new CustomError({
      return_message: "\uC798\uBABB\uB41C sortType\uC785\uB2C8\uB2E4."
    });
  }
  let t1;
  if ($[3] !== rawSortType) {
    t1 = () => {
      if (rawSortType === COMMENT_SORT_TYPE.LATEST) {
        return;
      }
      replaceSortTypeInUrl(COMMENT_SORT_TYPE.LATEST);
    };
    $[3] = rawSortType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const resetSortType = t1;
  let t2;
  if ($[5] !== rawSortType || $[6] !== resetSortType) {
    t2 = {
      sortType: rawSortType,
      handleChangeSortType: replaceSortTypeInUrl,
      resetSortType
    };
    $[5] = rawSortType;
    $[6] = resetSortType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};